/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TourTypeEnum = 1 | 2;

export const TourTypeEnum = {
    NUMBER_1: 1 as TourTypeEnum,
    NUMBER_2: 2 as TourTypeEnum
};

